import { z } from 'zod';
import { PERFILES } from '../../constants';

const PAIS_LABELS = ['Argentina', 'Mexico'] as const;

const baseFields = {
  nombre: z.string().trim().min(1, 'Ingresá el nombre'),
  usuarioApp: z
    .string()
    .trim()
    .min(1, 'Ingresá el usuario de aplicación')
    .max(80, 'Demasiado largo'),
  perfil: z.enum(PERFILES, { errorMap: () => ({ message: 'Seleccioná un perfil' }) }),
  /** One or more países the user can operate in. The first entry is the
   *  default landing country (Pais_USR); the full list becomes
   *  Paises_Permitidos_USR. Cross-country users switch via the
   *  CountrySwitcher just like cross-region admins do today. */
  paises: z
    .array(z.enum(PAIS_LABELS))
    .min(1, 'Seleccioná al menos un país'),
};

export const createUsuarioSchema = z.object({
  ...baseFields,
  password: z.string().min(1, 'Ingresá la contraseña'),
});
export type CreateUsuarioValues = z.infer<typeof createUsuarioSchema>;

/** On edit, password is optional (empty = keep current). */
export const editUsuarioSchema = z.object({
  ...baseFields,
  password: z.string().optional(),
});
export type EditUsuarioValues = z.infer<typeof editUsuarioSchema>;

export const emptyCreateUsuario: CreateUsuarioValues = {
  nombre: '',
  usuarioApp: '',
  perfil: 'Ventas',
  paises: ['Argentina'],
  password: '',
};
